import { 
    Button,
    Dialog, 
    DialogActions, 
    DialogContent,
    FormControlLabel,
    Grid,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
interface SeriesNameSettingProps {
    isOpen: boolean;
    onClose: VoidFunction;
    formik: any;
    disableSeriesName?: boolean;
    ignoreBackdropClose?: boolean;
};

const SeriesNameSetting = (props: SeriesNameSettingProps & { isButtonDisabled: boolean }) => {
    const {isOpen, onClose, formik, isButtonDisabled, disableSeriesName = false, ignoreBackdropClose = false} = props;

    return (
        <Dialog
            open={isOpen}
            onClose={(_event, reason) => {
                if (reason === "backdropClick" && ignoreBackdropClose) {
                    return;
                }
                onClose();
            }}
            fullWidth
        >
            <DialogActions>
                <Button onClick = {onClose}>x</Button>
            </DialogActions>
            <form onSubmit={formik.handleSubmit}>
            <DialogContent>
                <TextField
                    autoFocus={!disableSeriesName}
                    id = "description"
                    name = "description"
                    margin ="dense"
                    label = {
                        formik.touched.description && formik.errors.description ? 
                        formik.errors.description : 
                        "Enter Series Name"
                    }
                    type = "text"
                    fullWidth
                    value = {formik.values.description}
                    onChange = {formik.handleChange}
                    error = {formik.touched.description && formik.errors.description}
                    onBlur = {formik.handleBlur}
                    disabled={disableSeriesName}
                />
                <TextField
                    autoFocus={disableSeriesName}
                    margin="dense"
                    id="leagoCode"
                    name="leagoCode"
                    label={
                        formik.touched.leagoCode && formik.errors.leagoCode
                        ? formik.errors.leagoCode
                        : "Enter LEAGO Code"
                    }
                    type="text"
                    fullWidth
                    value={formik.values.leagoCode ?? ""}
                    onChange={formik.handleChange}
                    error={formik.touched.leagoCode && formik.errors.leagoCode}
                    onBlur={formik.handleBlur}
                />
                <Grid container spacing={2}> 
                    <Grid item xs={6}>
                        <TextField
                            id = "pimKey"
                            name = "pimKey"
                            margin ="dense"
                            label = {
                                formik.touched.pimKey && formik.errors.pimKey ? 
                                formik.errors.pimKey : 
                                "Enter PIM Key"
                            }
                            type = "text"
                            fullWidth
                            value = {formik.values.pimKey}
                            onChange = {formik.handleChange}
                            error = {formik.touched.pimKey && formik.errors.pimKey}
                            onBlur = {formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            margin = "dense"
                            id = "jdeCode"
                            name = "jdeCode"
                            label = {
                                formik.errors.jdeCode && formik.touched.jdeCode ?
                                formik.errors.jdeCode : 
                                "Enter JDE Code"
                            }
                            type = "text"
                            fullWidth
                            value = {formik.values.jdeCode ?? null}
                            onChange = {formik.handleChange}
                            error = {formik.touched.jdeCode && formik.errors.jdeCode}
                            onBlur = {formik.handleBlur}
                        />
                    </Grid>
                </Grid>
                <TextField
                    id = "budget"
                    name = "budget"
                    margin ="dense"
                    label = {
                        formik.touched.budget && formik.errors.budget ? 
                        formik.errors.budget : 
                        "Enter Tooling Budget"
                    }
                    type = "number"
                    fullWidth
                    value = {formik.values.budget}
                    onChange = {formik.handleChange}
                    error = {formik.touched.budget && formik.errors.budget}
                    onBlur = {formik.handleBlur}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                    }}
                />
                <h4>Set Active</h4>
                <RadioGroup
                    row
                    name = "isActive"
                    value = {formik.values.isActive}
                    onChange = {(event) => formik.handleChange(event)}
                >
                    <FormControlLabel value = {true} control = {<Radio/>} label = "Active"/>
                    <FormControlLabel value = {false} control = {<Radio/>} label = "Inactive"/>
                </RadioGroup>
                <DialogActions>
                    <Button variant = "contained" type = "submit" disabled={isButtonDisabled}>
                        {formik.values.id > 0 ? 
                            "Update Series Name": "Add Series Name"}
                    </Button>
                </DialogActions>
            </DialogContent>
            </form>
        </Dialog>
    )
}; 

export default SeriesNameSetting;